import {ImageViewer, FullScreenViewer} from "iv-viewer";
// import "bootstrap/js/dist/modal"
import {Modal} from "bootstrap"


$(function() {
    // ---------------------------
    // Создание на базе выбранного
    // ---------------------------
    const btnCreateSelectedBase = $("a#createSelectedBase")
    const checker = $("input[type=checkbox].js-item-check") || false
    function checkAvailable(e) {
        let checkedCount = 0

        checker.each(function(i, el) {
            if ($(el).is(":checked")) {
                checkedCount++;
            }
        })
        if (e) {
            e.preventDefault()
        }

        if (checkedCount > 0 && checkedCount < 2) {
            btnCreateSelectedBase.removeClass("disabled")
            return true
        } else {
            btnCreateSelectedBase.addClass("disabled")
            return false
        }

    }

    checker.on("change", function(e) {
        checkAvailable(e)
    })

    btnCreateSelectedBase.on("click", function(e) {
        if (checkAvailable()) {
            let href = $(this).attr("href")
            if (href) {
                const currentChecked = $("input[type=checkbox]:checked") || false
                if (currentChecked.length === 1) {

                    href += "?task_id=" + $(currentChecked).val()
                    $(this).attr("href", href)
                    window.location = href
                    return true
                }
            } else {
                e.preventDefault()
                e.stopPropagation()
            }
        } else {
            e.preventDefault()
            e.stopPropagation()
        }
    })
    checkAvailable()

    // -----------
    // Все вкладки
    // -----------

    let saveAll = $("input#confirmSaveAllTabs") || false;
    if (saveAll) {
        $(saveAll).closest("form").on("submit", function(e) {
            const msg = $(saveAll).data("confirm-message")
            if (msg && confirm(msg)) {
                $(saveAll).val("1")
            }
        })
    }

    // ---------------
    // Вкладка "Языки"
    // ---------------
    const currentLocalizationState = $("input[name=current_localization]") || null;

    function changeState() {
        if (!currentLocalizationState)
            return

        const currentValue = $(currentLocalizationState).val() || "__None"  // По-умолчанию "Нестандартная"
        const newValue = $($(currentLocalizationState).data("localization-selector")).find(":selected").val() || null

        if (newValue) {
            if (currentValue !== newValue) {
                const msg = $(currentLocalizationState).data("confirm-message") || null
                if (msg && confirm(msg)) {
                    return true
                }
            } else {
                return true
            }
        }

        return false
    }

    // Если локализация кастомная, затемняем кнопку "применить"
    const localizationSelector = "select.js-localization-selector"
    $(localizationSelector).on("change", function() {
        const applyButton = $("button.js-button-apply-localization")
        if ($(this).val() === "__None") {
            applyButton.prop("disabled", true)
        } else {
            applyButton.prop("disabled", false)
        }
    })
    $(localizationSelector).trigger("change")

    // Применение локализации
    $("button.js-button-apply-localization").on("click", function(e) {
        // Текущая установленная локализация
        if (!changeState()) {
            e.preventDefault()
        }
    })
    $("form#js-task-localization-form").on("submit", function(e) {
        if ($("input[name=changed_state]").val() === "1") {
            if (!changeState()) {
                e.preventDefault()
            }
        }
    })

    // Изменение настроек локализации сбрасывает выбранную локализацию из справочника
    $(".js-pkg-localization-change, .js-pkg-text-change").on("change", function (e) {
        const cleanElement = $(this).data("clean-element") || false;
        const element = $(cleanElement)

        if (cleanElement && element) {
            $(element).val("__None")
            $(element).trigger("change")
        }

        const checkSwitch = $(this).data("check-switch") || false;
        const checkElement = $(this).parents("tr").find("input[name='"+ checkSwitch + "']") || false;

        if (checkElement) {
            if ($(checkElement).is(":checked")) {
                $(checkElement).prop("checked", false)
            }
        }

        // Отмечаем что состояние было поменяно
        // Например, установлена локализация, но мы нажали на чекбоксы, в этом случае локализация должна
        // сохраняться на "Нестандартную"
        $("input[name=changed_state]").val("1")
    });

    // Групповая отметка
    $(":checkbox[data-pkg-group-selector]").on("change", function(event) {
        const self = $(this)
        const itemsCls = self.data("items") || false;
        const elements = $("." + itemsCls)

        elements.each((i, e) => {
            const switchData = $(e).parents("tr").find('input[name="' + $(e).data("check-switch") + '"]') || false;
            if (self.is(":checked")) {
                if (switchData) {
                    if (!$(switchData).is(":checked")) {
                        if (!$(e).is(":checked"))
                            $(e).trigger("click")
                    } else {
                    }
                }
            } else {
                if ($(e).is(":checked")) {
                    $(e).trigger("click")
                }
            }

        })

    })

    // ----------------
    // Вкладка "Тексты"
    // ----------------
    const relationModalEl = document.getElementById('relationModal') || null;
    let relationModal = null;

    if (relationModalEl) {
        relationModal = new Modal(relationModalEl, {backdrop: 'static', keyboard: false});
    }

    function showRelationModal(payload) {
      // payload = { relation: string, items: [{id:int|string, title:string, selected:bool}, ...] }
      if (!relationModalEl || !relationModal) {
          return;
      }

      if (!payload.items || payload.items.length === 0) {
        return; // нет элементов — ничего не показываем
      }

      const $modal     = $('#relationModal');
      const $title     = $modal.find('.modal-title');
      const $body      = $modal.find('.modal-body');

      // Заголовок
      $title.text(payload.relation ?? 'Выбор');

      // Контент
      $body.empty();

      if (!payload.items || !payload.items.length) {
        $body.append('<div class="text-muted">Нет элементов</div>');
      } else {
        // Генерируем чекбоксы
        payload.items.forEach((item, idx) => {
          // Стабильные id для label/for
          const cid = `relchk_${String(item.id).replace(/[^a-zA-Z0-9_\-:.]/g, '_')}_${idx}`;
          const $wrap = $(`
            <div class="form-check mb-2">
              <input class="form-check-input" type="checkbox" id="${cid}">
              <label class="form-check-label" for="${cid}"></label>
            </div>
          `);
          // Безопасно проставляем значения
          $wrap.find('input')
            .prop('checked', !!item.selected)
            .attr('data-rel-id', String(item.id))  // будем читать выбранные id по этому атрибуту
            .val(String(item.id));                 // на случай, если вам пригодится .val()
          $wrap.find('label').text(item.title ?? String(item.id));
          $body.append($wrap);
        });
      }

      // Показать
      relationModal.show();
    }

    // Обработчик кнопки "ОК"
    $('#relationModalOk').on('click', function () {
      if (!relationModalEl) return;
      const $modal = $('#relationModal');

      // Собираем id из модалки
      const selected = new Set(
        $modal.find('.form-check-input:checked')
              .map((_, el) => $(el).attr('data-rel-id'))
              .get()
      );

      const allFromDialog = new Set(
        $modal.find('.form-check-input')
              .map((_, el) => $(el).attr('data-rel-id'))
              .get()
      );

      // Меняем только элементы, которые были в диалоге
      $('input.js-pkg-text-change').each(function () {
        const val = String($(this).val());
        if (!allFromDialog.has(val)) {
          return; // пропускаем, если не было в модалке
        }
        const shouldCheck = selected.has(val);
        const wasChecked  = $(this).prop('checked');
        if (wasChecked !== shouldCheck) {
          $(this).prop('checked', shouldCheck).trigger('change');
        }
      });

      relationModal.hide();
    });

    // По закрытию — очищаем содержимое на всякий
    if (relationModalEl) {
        relationModalEl.addEventListener('hidden.bs.modal', () => {
          const $modal = $('#relationModal');
          $modal.find('.modal-title').empty();
          $modal.find('.modal-body').empty();
        });
    }

    const checkSelected = (accordionItem) => {
        const hasSelected = $(accordionItem).find("input:checked").length || false
        const accordionButton = $(accordionItem).find("button.accordion-button")

        if (hasSelected > 0) {
            $(accordionButton).addClass("has-selections").removeClass("no-selections")
        } else {
            $(accordionButton).removeClass("has-selections").addClass("no-selections")
        }
    }

    // Подсветка группы
    $(".js-pkg-text-change").on("change", function(e) {
        const accordionItem = $(this).closest(".accordion-item") || false;
        checkSelected(accordionItem)
    })
    $(".js-pkg-text-change").on("click", function(e) {
        // Тут дополнительно мы проверим элемент на наличие связей
        const checkUrl = $(this).data("check-url") || null;
        const isChecked = $(this).is(":checked")
        if (checkUrl && isChecked && relationModalEl) {
            $.ajax({
                url: checkUrl,
                success: function (data) {
                    showRelationModal(data)
                },
                fail: function(jqXHR, textStatus) {
                    alert(jqXHR.data.error)
                }
            })
        }
    })

    // Показ / выключение выбранных
    $("#switcherShowHideSelectedItems").on("change", function(e) {
        const checked = $(this).is(":checked")
        const accordionItems = $(".accordion-item")

        if (checked) {
            $(accordionItems).each((i, elem) => {
                // Скроем не выбранные чекбоксы
                $(elem).find("input:not(:checked)").each((ii, e) => {
                    $(e).parent(".form-check").addClass("d-none")
                })

                let btn = $(elem).find("button.accordion-button") || false;

                if (btn) {
                    if (btn.hasClass("has-selections")) {
                        // Если в группе есть отмеченные
                        if ($(btn).hasClass("collapsed")) {
                            // И группа скрыта, тогда ее откроем
                            $(btn).trigger("click")
                        }
                    } else {
                        // В группе нет отмеченных
                        if (!(btn).hasClass("collapsed")) {
                            // и группа открыта, закроем ее
                            $(btn).trigger("click")
                        }
                    }
                }
            })
        } else {
            // Просто закроем все группы
            $(accordionItems).each((i, elem) => {
                let btn = $(elem).find("button.accordion-button") || false;
                if (btn) {
                    if (!$(btn).hasClass("collapsed")) {
                        $(btn).trigger("click")
                    }
                }
                // Вернем обратно к показу скрытые чекбоксы
                $(elem).find("input:not(:checked)").each((ii, e) => {
                    $(e).parent(".form-check").removeClass("d-none")
                })
            })
        }
    })

    // ------------------------
    // Вкладка "Характеристики"
    // ------------------------
    const containersList = $("[data-df-package-property-customize]")
    containersList.each(function(index, element) {
        const container = $(element)
        const editButton = container.find("a") || false
        const switchControl = container.find(".js-property-string") || false
        const editForm = container.find(".js-property-editor") || false
        const info = switchControl.find(".js-property-string-info") || false

        editButton.on("click", function(e) {
            e.preventDefault()
            if (editForm) {
                if (editForm.hasClass("d-none")) {
                    editForm.removeClass("d-none")
                    switchControl.addClass("d-none")
                } else {
                    switchControl.removeClass("d-none")
                    editForm.addClass("d-none")
                }
            }
        })

        $(container).find("button[name=apply-result]").on("click", function(e) {
            e.preventDefault()
            const inputs = editForm.find(".js-property-editor-fields").find("input,select")

            $.ajax({
                url: $(this).data("url"),
                method: "POST",
                data: inputs.serialize(),
                success(data) {
                    const stringValue = data.as_string || false
                    const changed = data.changed || false
                    if (stringValue) {
                        editButton.html(stringValue)
                    }
                    if (!changed) {
                        info.addClass("d-none")
                    } else {
                        info.removeClass("d-none")
                    }
                    editButton.click()
                },
                error() {
                    alert("Что-то пошло не так")
                }
            })

        })
        $(container).find("button[name=revert]").on("click", function(e) {
            e.preventDefault()
            const inputs = editForm.find(".js-property-editor-fields").find("input,select")

            $.ajax({
                url: $(this).data("url"),
                data: inputs,  // .serialize(),
                method: "POST",
                success(data) {
                    const stringValue = data.as_string || false
                    const changed = data.changed || false
                    if (stringValue) {
                        editButton.html(stringValue)
                    }
                    if (!changed) {
                        info.addClass("d-none")
                    } else {
                        info.removeClass("d-none")
                    }

                    editButton.click()

                    const returnedData = data.ret_data || false

                    if (returnedData) {
                        for (let key in returnedData) {
                            const input = $("select[name=" + key + "], input[name=" +key+ "]") || false
                            if (input) {
                                input.val(returnedData[key])
                            }
                        }
                    }
                },
                error() {
                    alert("Что-то пошло не так")
                }
            })
            // editButton.click()
        })
        $(container).find("button[name=cancel]").on("click", function(e) {
            e.preventDefault()
            editButton.click()
        })
    })

    $("input[type=checkbox].js-mark-long-block-too").on("click", function(e) {
        const tr = $(this).parents("tr")
        const long = $(tr).find("input[type=checkbox].js-full-check")
        if ($(this).is(":checked")) {
            $(long).prop("checked", $(this).is(":checked"))
        }
    })

    // $("input[type=checkbox].js-mark-short-block-too").on("click", function(e) {
    //     if ($(this).is(":checked")) {
    //         const tr = $(this).parents("tr")
    //         const short = $(tr).find("input[type=checkbox].js-short-check")
    //         $(short).prop("checked", true)
    //     }
    // })
    // $("input[type=checkbox].js-mark-long-block-too").on("click", function(e) {
    //     if (!$(this).is(":checked")) {
    //         const tr = $(this).parents("tr")
    //         const short = $(tr).find("input[type=checkbox].js-full-check")
    //         $(short).prop("checked", false)
    //     }
    // })

    // container.each(function(number, element) {
    //     let editorContainer = $(container).find(".js-property-editor") || false
    //     const editButton = $(container).find("a").on("click", function(e) {
    //         $(e).preventDefault()
    //         if (editorContainer.hasClass("d-none")) {
    //             editorContainer.removeClass("d-none")
    //         } else {
    //             editorContainer.addClass("d-none")
    //         }
    //     })
    // })

    // ---------------------
    // Вкладка "Особенности"
    // ---------------------
    $("input[type=checkbox].js-language-short-check").on("click", function(e) {
        const tr = $(this).parents("tr")
        const b_desc = $(tr).find("input[type=checkbox].js-language-with-description-check")

        const c_short = $(tr).find("input[type=checkbox].js-add-to-short-block-check")
        const c_desc = $(tr).find("input[type=checkbox].js-add-to-short-block-description-check")

        if (!$(this).is(":checked")) {

            $(b_desc).prop("checked", $(this).is(":checked"))
            // $(b_desc).addClass("disallow")

            $(c_short).prop("checked", $(this).is(":checked"))
            // $(c_short).addClass("disallow")

            $(c_desc).prop("checked", $(this).is(":checked"))
            // $(c_desc).addClass("disallow")
        } else {
            // $(b_desc).removeClass("disallow")
            // $(c_short).removeClass("disallow")
            // $(c_long).removeClass("disallow")
        }
    })

    $("input[type=checkbox].js-language-with-description-check").on("click", function(e) {
        const tr = $(this).parents("tr")
        const b_short = $(tr).find("input[type=checkbox].js-language-short-check")
        if ($(this).is(":checked")) {
            $(b_short).prop("checked", $(this).is(":checked"))
        }
    })

    // Если отмечаем "короткая" в сокращённом блоке, то автоматически отмечаем "короткая" в блоке языков
    $("input[type=checkbox].js-add-to-short-block-check").on("click", function(e) {
        const tr = $(this).parents("tr")

        if ($(this).is(":checked")) {
            const long = $(tr).find("input[type=checkbox].js-language-short-check")
            $(long).prop("checked", $(this).is(":checked"))

        } else {
            $(tr).find("input[type=checkbox].js-add-to-short-block-description-check").prop("checked", $(this).is(":checked"))
        }
    })

    $("input[type=checkbox].js-add-to-short-block-description-check").on("click", function(e) {
        const tr = $(this).parents("tr")

        if ($(this).is(":checked")) {
            const b_short = $(tr).find("input[type=checkbox].js-language-short-check")
            $(b_short).prop("checked", $(this).is(":checked"))
            const c_short = $(tr).find("input[type=checkbox].js-add-to-short-block-check")
            $(c_short).prop("checked", $(this).is(":checked"))
        }
    })

    // --------------
    // Вкладка "Крой"
    // --------------
    // Uploader
    const preventDefaults = event => {
        event.stopPropagation()
        event.preventDefault()
    }
    const highlight = event => {
        $(event.target).addClass("highlight")
    }
    const unhighlight = event => {
        $(event.target).removeClass("highlight")
    }

    const getRefs = element => {
        const zone = $(element).closest(".upload_dropZone") || false
        const input = $(zone).find("input[type=file]") || false
        const container = $(zone).find(".upload_dropZone__content") || false
        return {zone: zone, input: input, container: container}
    }
    const handleDrop = event => {
        const dataRefs = getRefs(event.target)
        dataRefs.files = event.originalEvent.dataTransfer.files
        handleFiles(dataRefs)
    }
    const handleFiles = dataRefs => {
        let files = [...dataRefs.files]
        if (!files.length) return
        upload(dataRefs)
    }
    const upload = dataRefs => {
        if (!dataRefs || !dataRefs.files || !dataRefs.input) return
        const uploadUrl = $(dataRefs.input).data("post-url") || false
        if (!uploadUrl) return
        const name = $(dataRefs.input).data("post-name") || false
        if (!name) return

        const formData = new FormData()
        formData.append(name, dataRefs.files[0])

        // const savedContent = $(dataRefs.container).html()
        // console.log(savedContent)
        const error = $(dataRefs.container).find(".upload_dropZone__error") || false
        const upload = $(dataRefs.container).find(".upload_dropZone__upload") || false
        const loader = $(dataRefs.container).find(".upload_dropZone__loading") || false
        $(error).addClass("d-none")
        $(upload).addClass("d-none")
        $(loader).removeClass("d-none")

        $.ajax({
            url: uploadUrl,
            method: "POST",
            data: formData,
            processData: false,
            contentType: false,
            success: (data, textStatus, jqXHR) => {
                $(loader).addClass("d-none")
                $(upload).removeClass("d-none")

                // TODO: Здесь предпросмотр
                $(dataRefs.zone).replaceWith(data.preview)
                $(document).trigger("uploader-change")
                checkPublishState()
            },
            error: (jqXHR, textStatus, errorThrown) => {
                alert(errorThrown)
                $(loader).addClass("d-none")
                $(upload).removeClass("d-none")
                $(document).trigger("uploader-change")
                checkPublishState()
            }
        })
    }

    const eventHandlers = zone => {
        const dataRefs = getRefs(zone)
        if (!dataRefs.input) return

        $(zone).on("drag dragstart dragend dragover dragenter dragleave drop", preventDefaults)
        .on("dragover dragenter", highlight)
        .on("dragleave dragend drop", unhighlight)
        .on("drop", event => handleDrop(event))

        $(dataRefs.input).on("change", event => {
            dataRefs.files = event.target.files
            handleFiles(dataRefs)
        })
    }

    const eventAlreadyHandlers = zone => {
        $(zone).find(".alreadyUploaded__delete").on("click", function(event) {
            handleDelete(event, $(this))
        })
    }

    const handleDelete = (event, button) => {
        preventDefaults(event)
        const zone = $(button).parents(".alreadyUploaded")
        const message = $(button).data("message") || false

        if (message) {
            if (!confirm(message)) return
        }

        const deleteUrl = $(button).data("url") || false;
        if (!deleteUrl) return

        $.ajax({
            url: deleteUrl,
            method: "DELETE",
            success: function(data, textStatus, jqXHR) {
                $(zone).replaceWith(data.uploader)
                $(document).trigger("uploader-change")
            },
            error: function(jqXHR, textStatus, errorThrown) {
                alert("ERROR")
            }
        })
    }

    const attachEvents = () => {
        $(".upload_dropZone").each((i, zone) => eventHandlers(zone))
        $(".alreadyUploaded").each((i, zone) => eventAlreadyHandlers(zone))
    }

    $(document).on("uploader-change", event => attachEvents())
    attachEvents()

    // Дополнительные файлы
    const filesContainer = $("#additionalFilesContainer")

    $("#newAdditionalFile").on("click", function(e) {
        // Добавить файл
        e.preventDefault()

        $.ajax({
            url: $(this).data("url"),
            success: function(data) {
                $(filesContainer).prepend(data.preview)
                $(document).trigger("uploader-change")
            },
            error: function() {
                alert("Что-то пошло не так")
            }
        })
    })

    // -----------------------------
    // Вкладка "Задание и результат"
    // -----------------------------

    $(document).on("click", ".js-delete-confirmation-button", function(e) {
        const confirmMessage = $(this).data("message") || false
        if (confirmMessage && confirm(confirmMessage)) {
            const url = $(this).data("url") || false
            const container = $(this).parents(".js-result-preview")
            if (url) {
                $.ajax({
                    method: "DELETE",
                    url: url,
                    success: function(data) {
                        $(container).replaceWith(data.preview)
                        $(document).trigger("uploader-change")
                    },
                    error: function() { alert("Что-то пошло не так") }
                })
            }
        }
    })

    $(document).on("change", "input[type=checkbox].js-task-publish", function(e) {
        const parentContainer = $(this).parents(".js-product-task-publish-block")
        const unpublishReasonBlock = $(parentContainer).find(".js-unpublish-reason")

        if (!$(this).is(":checked")) {
            unpublishReasonBlock.removeClass("d-none")
        } else {
            unpublishReasonBlock.addClass("d-none")
        }
    });

    // Галочка "опубликовать" должна быть активна только если выбраны локали:
    // хотя бы один "на лицевой стороне" и хотя бы один в "полном блоке" или "сокращенном блоке"
    const allFrontCheckboxes = $("div.js-front-locales-checkboxes input[type=checkbox]") || []
    const allFullBlockCheckboxes = $("div.js-full-block-locales-checkboxes input[type=checkbox]") || []
    const allShortBlockCheckboxes = $("div.js-short-block-locales-checkboxes input[type=checkbox]") || []

    let frontSelected = 0
    let otherSelected = 0

    $.each(allFrontCheckboxes, (index, item) => $(item).is(":checked") ? frontSelected++ : null)
    $.each(allFullBlockCheckboxes, (index, item) => $(item).is(":checked") ? otherSelected++ : null)
    $.each(allShortBlockCheckboxes, (index, item) => $(item).is(":checked") ? otherSelected++ : null)

    function checkPublishState() {
        let result = false
        if (frontSelected > 0 && otherSelected > 0) {
            result = true
        }

        const publishButton = $("input[type=checkbox].js-task-publish") || null;

        if (result) {
            $(publishButton).prop("disabled", false)
        } else {
            $(publishButton).prop("disabled", true)
        }
    }

    $(allFrontCheckboxes).on("click", function(e) {
        if ($(this).is(":checked")) {
            frontSelected++
        } else {
            if (frontSelected > 0) {
                frontSelected--
            }
        }
        checkPublishState()
    })

    function changeOtherCheckboxStates(item) {
        if ($(item).is(":checked")) {
            otherSelected++
        } else {
            if (otherSelected > 0) {
                otherSelected--
            }
        }
        checkPublishState()
    }

    $(allFullBlockCheckboxes).on("click", function (e) {
        changeOtherCheckboxStates($(this))
    })
    $(allShortBlockCheckboxes).on("click", function(e) {
        changeOtherCheckboxStates($(this))
    })

    checkPublishState()
    // Конец блока логики работы с чекбоксом "Опубликовать"


    // -----------------------------
    // Общий список заданий в товаре
    // -----------------------------
    $("#createLastBase, #createSelectedBase").on("click", function(e) {
        if (!e.isDefaultPrevented()) {
            if (confirm($(this).data("msg"))) {
                if ($(this).attr("id") == "createSelectedBase") {
                    // alert("123")
                    e.preventDefault()
                }

                return true;
            }
            e.preventDefault()
        }
    })

    $("#removeSelectedTasks").on("click", function(e) {
        if (!e.isDefaultPrevented()) {
            e.preventDefault()

            let rows = []
            let values = []


            $("input[type=checkbox].js-item-check:checked").each(function(index, element) {
                values.push($(element).val())
                rows.push($(element).parents("tr"))
            })

            $.ajax({
                method: "POST",
                url: $(this).attr("href"),
                data: {
                    ids: values
                },
                success(data, textStatus, jqXHR) {
                    $(rows).each(function(i, el) {
                        $(el).remove()
                    })
                    $(":checkbox[data-group-selector]").each(function(i, el) { $(el).prop("checked", false) })
                }
            })
        }
    })

    $("#createSelectedBase").on("click", function(e) {

    })

    // -----------------------------------
    // Редактирование текстов для упаковки
    // -----------------------------------
    $("button#addTextItem").on("click", function(event) {
        event.preventDefault();
        const url = $(this).data("url")
        const container = $("tbody.js-text-item-rows") || null

        $.ajax({
            url: url,
            method: "GET",
            success: function(data) {
                if (data.preview && container) {
                    $(container).append(data.preview)
                }
            }
        })
    })

    $(document).on("click", "button.js-delete-text-item-row", function(event) {
        event.preventDefault()
        const url = $(this).data("url")
        const msg = $(this).data("message")
        const self = $(this)

        if (msg && confirm(msg)) {
            $.ajax({
                url: url,
                method: "DELETE",
                success(data, textStatus, jqXHR) {
                    self.parents("tr").remove()
                },
                error: function () {
                    alert("Что-то пошло не так!")
                }
            })
        }
    })

    // Предпросмотр результата в отдельном окне
    $(document).on("click", "a.df-run-previewer", function(e) {
        e.preventDefault()
        const modal = document.getElementById("resultPreviewModal")
        const container = document.querySelector("#resultPreviewModalBody")

        const viewerModal = new Modal(modal, {})
        const self = $(this)
        const lowResImg = $(this).data("low-res-img")
        const highResImg = $(this).data("high-res-img")


        let viewer = new ImageViewer(container, {
            hasZoomButtons: true,
        })
        viewerModal.show()
        viewer.load(lowResImg, highResImg)

        modal.addEventListener("hide.bs.modal", event => {
            viewer.destroy()
            viewer = null
        })
    })

    // ---------------------------------------------------------------
    // Особенности: при отметке «С описанием» отмечаем первое описание,
    // если в строке не отмечено ни одно
    // ---------------------------------------------------------------
    const withDescriptionClasses = [
        "js-front-with-description-check",
        "js-language-with-description-check",
        "js-add-to-short-block-description-check",
    ]

    function checkFirstDescription(tr) {
        const descriptions = $(tr).find(':checkbox[name$="[descriptions]"]')
        if (!descriptions.filter(":checked").length) {
            descriptions.first().prop("checked", true)
        }
    }

    $(document).on("change", withDescriptionClasses.map(c => ":checkbox." + c).join(", "), function(e) {
        if ($(this).is(":checked")) {
            checkFirstDescription($(this).closest("tr"))
        }
    })

    // Групповая отметка в шапке (app.js) не генерирует change на галочках строк.
    // Делегированный обработчик срабатывает после неё, галочки уже проставлены
    $(document).on("change", ":checkbox[data-group-selector]", function(e) {
        const cls = $(this).data("items")
        if (!withDescriptionClasses.includes(cls) || !$(this).is(":checked")) {
            return
        }
        $(":checkbox." + cls + ":checked").each(function(i, el) {
            checkFirstDescription($(el).closest("tr"))
        })
    })
});
